<script>
  import { afterUpdate, createEventDispatcher } from "svelte"
  import notify from "../../../../../Script/notify"
  import { loadTooltip } from "../../../../../Script/loadTooltip"
  import { copyToClipboard } from "../../../../Publish/SinglePublish/script"
  const dispatch = createEventDispatcher()

  /**
   * @type {copiedInfo}
   */
  let copiedInfo = {
    close() {},
  }

  export let signer = {}

  afterUpdate(() => {
    loadTooltip()
    window.addEventListener("resize", loadTooltip)
  })
</script>

<div class="flex w-full items-center justify-between rounded-r-md border-l-8 {signer.revoked ? 'border-red-500 dark:hover:border-red-500' : 'border-green-500 dark:hover:border-green-500'} bg-white py-2 px-3 text-white hover:shadow-md dark:border-y-2 dark:border-r-2 dark:border-y-transparent dark:border-r-transparent dark:bg-lightgray dark:hover:border-blue-500">
  <div class="flex flex-col truncate pl-2">
    <h2 title={signer.name} class="select-none truncate text-sm font-bold text-gray-d00 dark:text-white/70 md:text-lg">
      {signer.name}
      <span class="text-sm font-normal">({signer.designation})</span>
    </h2>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <h2
      on:click={async () => {
        try {
          copiedInfo.close()
          await copyToClipboard(signer.email)
          copiedInfo = notify.info("Signer Email copied to clipboard")
        } catch (error) {
          const info = "PAGE: Signer List\nEVENT: While copying Signer email"
          copiedInfo = notify.danger(error, info)
        }
      }}
      class="cursor-pointer select-none truncate text-xs font-medium text-gray-500 md:text-sm"
    >
      <!-- {new Date(template.created).toString().slice(0, 24)} -->
      {signer.email}
    </h2>
    <p class="mt-2 w-full select-none truncate text-xs font-normal text-gray-200 md:text-sm">
      <i class="fa-solid fa-calendar-days" />
      &nbsp;&nbsp;{new Date(signer.created).toString().slice(0, 24)}
    </p>
  </div>

  <div class="flex items-center justify-end px-3 text-gray-100">
    <a href="#/signing/signer/add?id={signer.id}" name="tooltip" id="View Signer Details" tooltip-position="top" class="flex cursor-pointer select-none items-center justify-center rounded-full px-3 py-2 text-sm font-medium text-yellow-500 hover:bg-yellow-500 hover:text-white focus:outline-none active:text-white sm:px-5">
      <i class="fa-solid fa-eye" />
      <span class="hidden lg:block">&nbsp;&nbsp;View&nbsp;Signer</span>
    </a>
    <button
      on:click={async () => {
        try {
          copiedInfo.close()
          await copyToClipboard(signer.id)
          copiedInfo = notify.info("Signer ID copied to clipboard")
        } catch (error) {
          const info = "PAGE: Signer List\nEVENT: While copying Signer id"
          copiedInfo = notify.danger(error, info)
        }
      }}
      name="tooltip"
      id="Copy ID"
      tooltip-position="top"
      class="flex cursor-pointer select-none items-center justify-center rounded-full px-3 py-2 text-sm font-medium text-sky-500 hover:bg-sky-500 hover:text-white focus:outline-none active:text-white sm:px-5"
    >
      <i class="fa-solid fa-id-card" />
      <span class="hidden lg:block">&nbsp;&nbsp;Copy&nbsp;ID</span>
    </button>
    <button on:click={() => dispatch("revoke")} name="tooltip" id={signer.revoked ? "Revoked Signer" : "Revoke Signer"} tooltip-position="top" disabled={signer.revoked} class="flex cursor-pointer select-none items-center justify-center rounded-full px-3 py-2 text-sm font-medium text-red-500 hover:bg-red-500 hover:text-white focus:outline-none active:text-white disabled:cursor-not-allowed disabled:text-gray-500 disabled:hover:bg-transparent sm:px-5">
      <i class="fa-solid fa-user-slash" />
      <span class="hidden lg:block">&nbsp;&nbsp;{signer.revoked ? "Revoked" : "Revoke"}</span>
    </button>
  </div>
</div>
